import { Component, input, output } from '@angular/core';
import { TTranslationKey } from '../../features/translate/types';

@Component({
  selector: 'pp-toggle-button',
  templateUrl: './toggle-button.component.html',
  styleUrls: ['./toggle-button.component.scss'],
  standalone: false,
})
export class ToggleButtonComponent {
  ppIsSelected = input<boolean>(false);
  ppSelectText = input<TTranslationKey>('select_all');
  ppDeselectText = input<TTranslationKey>('deselect_all');

  ppHandleDeselect = output<void>();
  ppHandleSelect = output<void>();
}
